import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/healthcare')({
  component: HealthcareIndustryPage,
});

function HealthcareIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="healthcare" />
    </DefaultLayout>
  );
}
